import { PropsWithChildren } from 'react'
import { Text, TextVariant } from 'blaze-ui/Text/Text'

export const Message = ({
  children,
  variant = 'largeList',
  color,
}: PropsWithChildren<{ variant?: TextVariant; color?: string }>) => (
  <Text variant={variant} color={color}>
    {children}
  </Text>
)
